import React from 'react';
import { NavLink } from 'react-router-dom';

// Sticky sub-navigation shared by all /trust/* pages.
// Mobile: horizontal scroll. Desktop: pinned under section header.
const TRUST_LINKS = [
  { to: '/trust',            label: 'Overview',   testid: 'trust-nav-overview' },
  { to: '/trust/security',   label: 'Security',   testid: 'trust-nav-security' },
  { to: '/trust/privacy',    label: 'Privacy',    testid: 'trust-nav-privacy' },
  { to: '/trust/compliance', label: 'Compliance', testid: 'trust-nav-compliance' },
];

const TrustSubNav = () => (
  <nav
    data-testid="trust-subnav"
    className="sticky top-0 z-20 border-b border-hairline surface-obsidian-2 backdrop-blur"
  >
    <div className="mx-auto max-w-[1440px] px-5 md:px-8">
      <ul className="flex gap-1 overflow-x-auto py-3 text-sm md:gap-2">
        {TRUST_LINKS.map((l) => (
          <li key={l.to} className="flex-shrink-0">
            <NavLink
              end={l.to === '/trust'}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                `inline-flex items-center px-3 py-2 font-mono-data text-[12px] uppercase tracking-[0.14em] transition-colors ${
                  isActive
                    ? 'border border-gold-soft text-gold bg-[rgba(200,166,74,0.08)]'
                    : 'border border-transparent text-platinum-2 hover:text-gold hover:border-hairline'
                }`
              }
            >
              {l.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  </nav>
);

export default TrustSubNav;
